import { Component, Input } from "@angular/core";
import { NgStyle } from "@angular/common";

@Component({
  selector: "app-text",
  templateUrl: "./text.component.html",
  styleUrls: ["./text.component.scss"],
  imports: [NgStyle],
  standalone: true,
})
export class TextComponent {
  @Input() color = "dark-shade";

  @Input() weight = "400";

  @Input() size = "";
}
